export const LAST_ACTIVITY_KEY: string = 'alk-last-activity';
